const $inject = [];
const lbaApiMultiSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaApiMultiSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaApiMultiSelect.html')
  }
};

lbaApiMultiSelect.$inject = $inject;

export default lbaApiMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lbaApiMultiSelect/lbaApiMultiSelectDir.js